import React from 'react';
import { useTranslation } from 'react-i18next';

import Badge from 'pages/hotels/component/Layout/Header/__partials/Badge';

import { getDecimalNumber } from 'utility/Format/Number';
import { getFormattedPrice } from 'utility/Format/Price';

import styles from './Headline.module.scss';

interface HeadlineProps {
    text: string;
    badge: string;
    resultCount: number;
    minPricePerPerson: number;
    maxPrice: number;
    minPrice: number;
    isLoading: boolean;
}

const Headline = ({
    text,
    badge,
    resultCount,
    minPricePerPerson,
    maxPrice,
    minPrice,
    isLoading,
}: HeadlineProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={styles.Headline}>
                {text && <h1 dangerouslySetInnerHTML={{ __html: text }} />}
                {isLoading ? (
                    <h2>{t('TRANS-find-your-next-holiday')}</h2>
                ) : (
                    <>
                        {!!badge ? (
                            <h2>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: t(
                                            'TRANS-hotel-for-your-travel[i]',
                                            {
                                                postProcess: 'interval',
                                                count: resultCount,
                                                resultCount: getDecimalNumber(
                                                    resultCount,
                                                    0
                                                ),
                                            }
                                        ),
                                    }}
                                />
                                <span
                                    className={styles.PriceRange}
                                    dangerouslySetInnerHTML={{
                                        __html: t(
                                            'TRANS-price-range-and-per-person-price',
                                            {
                                                min: getFormattedPrice(
                                                    minPrice
                                                ),
                                                max: getFormattedPrice(
                                                    maxPrice
                                                ),
                                                perPersonMin:
                                                    getFormattedPrice(
                                                        minPricePerPerson
                                                    ),
                                            }
                                        ),
                                    }}
                                />
                            </h2>
                        ) : (
                            <h2>
                                {resultCount === 0
                                    ? t('TRANS-no-results')
                                    : t('TRANS-find-your-next-holiday')}
                            </h2>
                        )}
                    </>
                )}
            </div>
            {badge && <Badge semBadge={parseInt(badge)} />}
        </>
    );
};

export default Headline;
